import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  itemVariantsNoY,
  viewPort,
} from '../../../utils/framer';

interface BoxWithLineProps {
  boxes: {
    title: string;
    text: string;
    boxColor: string;
  }[];
  lineColor: string;
}

const BoxesWithLines: React.FC<BoxWithLineProps> = ({ boxes, lineColor }) => {
  return (
    <m.div
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className="relative"
    >
      <m.div
        variants={itemVariantsNoY}
        className={`absolute md:hidden top-12 left-1/2 ${lineColor} `}
        style={{
          width: '4px',
          height: 'calc(100% - 55px)',
          zIndex: 0,
        }}
      ></m.div>
      <m.div
        variants={itemVariantsNoY}
        className={`hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${lineColor}`}
        style={{
          width: 'calc(80% - 85px)',
          height: '4px',
          zIndex: 0,
        }}
      ></m.div>
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className="relative md:place-items-center mx-auto flex flex-col md:grid items-center justify-around space-y-12 md:space-y-0 md:grid-cols-3 my-12 md:mb-20"
      >
        {boxes.map((box, index) => (
          <m.div
            variants={itemVariants}
            key={index}
            className={`max-w-[440px] w-[85%] flex flex-col gap-2 h-full px-4 py-6 text-center ${box.boxColor}`}
          >
            <h2 className="font-bold text-lg tracking-[4px]">{box.title}</h2>
            <p>{box.text}</p>
          </m.div>
        ))}
      </m.div>
    </m.div>
  );
};

export default BoxesWithLines;
